<template>
  <div
    class="prompts__grid-container cr-w-100 gap-2"
    :class="{
      'prompts__grid-container--single-column': singleColumn,
    }"
  >
    <ClientHomePageStarterPrompt
      v-for="prompt in fourPromptsFromPool"
      :key="prompt.text"
      :emoji="prompt.emoji"
      :text="prompt.text"
      @prompt-clicked="$emit('prompt-clicked', $event)"
    />
  </div>
</template>

<script>
import { shuffle } from 'lodash'
import ClientHomePageStarterPrompt from './ClientHomePageStarterPrompt.vue'

const prompts = [
  { emoji: '📅', text: 'Do I have any deliveries coming today?' },
  { emoji: '🍪', text: 'Give me a fun snack fact.' },
  { emoji: '🔧', text: 'I need help from a Crafty team member.' },
  { emoji: '🍫', text: 'What are the nutrition facts of RXBARs?' },
  { emoji: '💪', text: 'What are some recommended high-protein brands?' },
  { emoji: '♻️', text: 'What are the most sustainable office beverages?' },
  { emoji: '🏬', text: 'What are the most popular office attendance days?' },
  { emoji: '⭐️', text: 'What are fun new brands Crafty suggests?' },
  { emoji: '🍿', text: 'What products does Crafty suggest?' },
]

export default {
  name: 'ClientHomePageStarterPrompts',
  components: {
    ClientHomePageStarterPrompt,
  },
  props: {
    singleColumn: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['prompt-clicked'],
  data() {
    return {
      prompts,
    }
  },
  computed: {
    fourPromptsFromPool() {
      return shuffle([...this.prompts]).slice(0, 4)
    },
  },
}
</script>

<style lang="scss" scoped>
.prompts {
  &__grid-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-auto-rows: 1fr;

    @media(min-width: 500px) {
      grid-template-columns: repeat(2, 1fr);

      &--single-column {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }
}
</style>
